import React, { createContext, useContext } from 'react';

// Exported so callers that render OUTSIDE OrgProvider (e.g. the org-less
// /membership/payment-* fallback routes) can read it defensively via
// useContext(OrgContext) without triggering useOrg()'s hard throw.
export const OrgContext = createContext(null);

export const useOrg = () => {
  const ctx = useContext(OrgContext);
  if (!ctx) {
    throw new Error('useOrg must be used within an OrgProvider (route under /o/:orgSlug)');
  }
  return ctx;
};

export const orgPath = (slug, path = '') => {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/o/${slug}${path === '' ? '' : clean}`;
};

export const OrgProvider = ({ org, children }) => {
  const value = {
    org,
    orgId: org?.id,
    orgSlug: org?.slug,
    orgName: org?.name,
    path: (p) => orgPath(org?.slug, p),
  };
  return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>;
};
